import { useEffect, useState } from 'react'
import { Button } from '@chakra-ui/react'

import { File } from 'DigitalArchive/types'
import FileCard from 'DigitalArchive/components/FileCard'
import { Loader } from 'components'
import getFileFromArchive from 'services/calls/file/getFileFromArchive'
import { openFile } from 'utils/files'
import { Document } from 'components/icons'

type Props = {
  fileId?: string
  fileSlug?: string
  archiveId?: string
}

export default function CustomFormFileAnswer({ fileId, fileSlug, archiveId }: Props) {
  const [loadingFile, setLoadingFile] = useState(true)
  const [file, setFile] = useState<File>({})

  async function loadFile() {
    setLoadingFile(true)
    const response = await getFileFromArchive({
      fileId,
      fileSlug,
      archiveId,
    })
    if (response?.header?.success) {
      const fileFromAPI = response?.body?.file
      setFile(fileFromAPI)
    }
    setLoadingFile(false)
  }

  useEffect(() => {
    loadFile()
  }, [])

  if (loadingFile) {
    return <Loader text="Carregando arquivo" />
  }

  return (
    <FileCard hasMetadatas={false} file={file}>
      <Button variant="outline" minWidth="100%" leftIcon={<Document />} onClick={() => openFile(file.url || '')}>
        Abrir arquivo
      </Button>
    </FileCard>
  )
}
